var _ellipse, _path, _polygon, _path2, _path3, _circle, _circle2, _path4, _circle3, _path5, _circle4, _path6, _circle5, _path7, _circle6, _path8, _circle7, _circle8, _circle9, _rect, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle10, _path17, _path18, _path19, _path20, _path21, _path22, _polygon2, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be52d4a0-d7df-45d7-a4d1-9b9d295e8f0e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 825.21102,
    height: 661.1631,
    viewBox: "0 0 825.21102 661.1631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "analyze") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 614.91339,
    cy: 645.1631,
    rx: 191,
    ry: 16,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M992.30789,585.59987c0,78.4056-46.61089,105.78191-104.10834,105.78191S784.09122,664.00547,784.09122,585.59987,888.19955,407.45,888.19955,407.45,992.30789,507.19426,992.30789,585.59987Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "697.013 559.97 698.079 494.351 742.452 413.172 698.246 484.058 698.725 454.553 729.307 395.82 698.852 446.745 698.852 446.745 699.714 393.679 732.462 346.921 699.85 385.335 700.388 288.032 697.003 416.844 697.281 411.53 663.986 360.566 696.747 421.731 693.645 480.996 693.553 479.423 655.169 425.791 693.437 484.98 693.049 492.391 692.979 492.503 693.011 493.111 685.14 643.472 695.656 643.472 696.918 565.808 735.091 506.764 697.013 559.97",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M959.7812,726.6927c0,22.46856-13.35644,30.31375-29.83387,30.31375q-.57256,0-1.14332-.01273c-.76344-.01636-1.51961-.05271-2.26668-.10361-14.87058-1.05244-26.42387-9.30116-26.42387-30.19741,0-21.62515,27.63446-48.91242,29.71026-50.93189l.00363-.00363c.08-.07816.12-.11634.12-.11634S959.7812,704.22414,959.7812,726.6927Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f51b5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M928.86035,753.56917,939.772,738.32233l-10.93889,16.921-.02907,1.75044c-.76344-.01636-1.51961-.05271-2.26668-.10361l1.17606-22.47946-.00909-.17451.02-.03271.11087-2.12307L916.869,715.1176l11.00071,15.37045.02547.45079.88884-16.98456-9.38839-17.52807,9.5029,14.547.92521-35.21244.00363-.12v.11634l-.1545,27.76715,9.34661-11.008-9.38477,13.40007-.2472,15.20685,8.72676-14.59429-8.76311,16.83189-.13815,8.4541,12.66935-20.31277-12.71661,23.2629Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 225.20654,
    cy: 209.20577,
    r: 47.90365,
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.11764,
    cy: 194.88974,
    r: 47.90365,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.88752,238.87371l-38.5677-64.60087a30.80147,30.80147,0,1,0-12.66485,9.5017Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.72273,
    cy: 35.76153,
    r: 14.31603,
    fill: "#3f51b5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M479.58793,231.41336l53.35158-53.05044a30.80149,30.80149,0,1,0-12.28336-9.99Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.2156,
    cy: 30.84181,
    r: 14.31603,
    fill: "#3f51b5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M516.75252,349.63452l64.38153,38.93275a30.80147,30.80147,0,1,0,6.72162-14.3353Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.07273,
    cy: 274.64438,
    r: 14.31603,
    fill: "#3f51b5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M411.034,414.29545l-22.201,71.8878a30.80148,30.80148,0,1,0,15.53558,3.05394Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.44443,
    cy: 397.52645,
    r: 14.31603,
    fill: "#3f51b5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M322.71811,327.36007l-75.12333-4.15027a30.80146,30.80146,0,1,0,.79517,15.81292Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.83766,
    cy: 213.17962,
    r: 14.31603,
    fill: "#3f51b5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 810.45546,
    cy: 48.5151,
    r: 14.75556,
    fill: "#f2f2f2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.45546,
    cy: 43.5151,
    r: 14.75556,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 683.91339,
    y: 51.82976,
    width: 33.33333,
    height: 33.33333,
    fill: "#3f51b5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 690.58006,
    y: 45.1631,
    width: 33.33333,
    height: 33.33333,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M794.80789,706.08155s-3,19-8,22,26,10,26,10l5-30Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#fbbebe"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M831.80789,489.08155l11,13-5,45-4,89s8,77,0,79-44,1-43-4,2-9,4-16-2-32-2-32l5-28-18-121Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M795.80789,725.08155s-11-2-12,0-20,23-23,23-25,20-2,21,61-17,61-17-5.59226-25.44648-5.29613-24.22324S795.80789,730.08155,795.80789,725.08155Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M783.80789,679.08155s28,31,29,34,16,0,16,0l6-20-5-7-28-23Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#fbbebe"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M823.80789,702.08155l-14.5,13.64811s18.5,28.35189,18.5,31.35189,1,28,11,24,11-44,11-44-1-41-7-44-19.15048-2.05218-19.15048-2.05218S831.80789,701.08155,823.80789,702.08155Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M740.80789,400.08155s-5,16-6,20-7,15-7,32,2,37,0,39-34,114-20,126,60,52,63,57,4,17,10,15,29-22,30-26-13-11-13-11-28-41-35-40-6-5-5-8,3-5,0-5-1-8,0-12,24-58,24-58l61-27s-3-73-25-93l-5-12S756.80789,393.08155,740.80789,400.08155Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M765.80789,242.08155s5,35-7,37-22,1-22,2,30,32,30,32l28-2,25-27s-23-4-23-18-1-24-1-24Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#fbbebe"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M765.80789,242.08155s5,35-7,37-22,1-22,2,30,32,30,32l28-2,25-27s-23-4-23-18-1-24-1-24Z",
    transform: "translate(-187.39449 -119.41845)",
    opacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 593.91339,
    cy: 106.1631,
    r: 31,
    fill: "#fbbebe"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M753.80789,276.08155s-39,5-42,18,20,94,23,101,2,12,2,12a39.56624,39.56624,0,0,1,32-7c19,4,46,2,46,2s9-37,11-41,10-26,10-32,12-31,12-31-6-18-28-17c0,0-9.59619-4.29506-12.2981-1.14753s-17.7019,17.14753-36.7019,11.14753S753.80789,276.08155,753.80789,276.08155Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M722.80789,293.08155h-11l-6,79s22,6,25,2S722.80789,293.08155,722.80789,293.08155Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M708.80789,364.08155l-3,8s-2,26,10,25,19-16,19-16-7-19-15-17S708.80789,364.08155,708.80789,364.08155Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M828.80789,293.08155l19,5s14,51,15,52,2,7,2,7,0,1,2,4,5,1,3,5-5,2-3,6,1,15,1,15-5-19-23-14l-12-54Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M745.9977,200.03915c-6.30387,11.07583-7.72367,24.19485-8.5935,36.90926-.373,5.45291-.65355,11.0496.96379,16.27049,1.70539,5.50511,5.4998,11.09855,3.554,16.52334-1.882,5.24677-8.17575,7.34634-11.69047,11.67267-2.97854,3.66635-3.72668,8.68974-3.46821,13.40641s1.40212,9.34719,1.73759,14.059a41.64844,41.64844,0,0,1-8.95862,28.70467c15.062-.58079,31.16569-7.25987,37.51746-20.92941,1.89885-4.08648,2.82264-8.55867,4.5362-12.72624,1.93849-4.71462,4.86362-8.98191,6.69952-13.73742,2.77-7.17506,2.91992-15.05376,3.03495-22.74409.06886-4.60347.11784-9.3298-1.47524-13.64938-3.5069-9.50884-14.413-15.65265-15.49588-25.72953a5.08932,5.08932,0,0,1,.45026-3.13278,8.31049,8.31049,0,0,1,1.82852-1.84924c6.81007-6.01057,5.68712-18.73554,13.79358-22.833,3.6377-1.8387,8.02262-1.19186,11.92889-.02791,4.33767,1.2925,8.66546,3.29415,11.48753,6.83278,5.68287,7.1258,3.44023,17.41912,1.68177,26.36226a157.36686,157.36686,0,0,0-2.68956,39.41209,25.50329,25.50329,0,0,0,.92671,6.242c1.04417,3.30071,3.27011,6.07363,4.95045,9.10042a30.06314,30.06314,0,0,1,3.13677,20.4182c-1.24046,6.0595-4.32181,12.51267-1.6093,18.07133a16.31963,16.31963,0,0,0,4.8657,5.41037c8.8623,6.946,20.11192,11.24975,26.70123,20.38039,1.13481-7.458-1.03-14.96325-2.62816-22.33584s-2.57068-15.39914.71364-22.19049c1.44085-2.97938,3.64313-5.57162,4.821-8.66442,2.72027-7.1427-.52193-14.97707-2.49089-22.36228a133.16267,133.16267,0,0,1-3.04126-17.6228l-2.03071-16.02185c-1.67877-13.24512-3.43529-26.76-9.25142-38.77771-10.96053-22.64746-35.76442-31.05863-57.97278-18.50938A37.55093,37.55093,0,0,0,745.9977,200.03915Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#ff6584"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M718.80789,369.08155s-6,18,1,18,20-11,21-20,19-43,6-40-19,28-19,28Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#fbbebe"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "632.413 173.663 599.413 280.663 644.413 290.663 677.413 186.663 632.413 173.663",
    fill: "#3f51b5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M861.80789,370.08155l6.24722,10.44031s2.75278,19.55969-11.24722,19.55969-34-19-34-19-10-4-16-3-39,0-25-17,38,0,38,0l25,12,13-7Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#fbbebe"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M853.30789,356.58155l-10,16s23,3,25,8-9-26-9-26Z",
    transform: "translate(-187.39449 -119.41845)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.bb56ae9bd8f51fbfad46177f20a2eae3.svg";
export { ForwardRef as ReactComponent };